<template>
  <div class="main products feature">
    <div class="mainContent">
      <div class="feature-compare">
        <el-table
          :data="tableData"
          row-class-name="self-row"
          style="width: 100%" header-row-class-name="table-title title" cell-class-name="feature-compare-detail">
          <el-table-column
            prop="features"
            :label="$t('p-title1')">
            <template slot-scope="scope">
               {{ $t(scope.row.features) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="crait"
            :label="$t('p-title2')">
            align="center">
            <template slot-scope="scope">
            <el-button v-if="scope.row.crait === 'getStarted'" class="cur get-start" @click="getStarted">{{ $t('btn1') }}</el-button>
              <div v-else-if="scope.row.crait === 'Support'"><i class="el-icon-check"></i></div>
              <div v-else-if="scope.row.crait === 'Not Support'"><i class="el-icon-close"></i></div>
              <div v-else-if="scope.row.crait !== 'Support' &&  scope.row.crait !=='Not Support'">{{$t(scope.row.crait)}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="craitPro"
            :label="$t('p-title3')">
            align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.craitPro === 'Upgrade'" type="primary" class="cur upgrade" @click="upgrade">{{ $t('btn2') }}</el-button>
              <div v-else-if="scope.row.craitPro === 'Support'"><i class="el-icon-check"></i></div>
              <div v-else-if="scope.row.craitPro === 'Not Support'"><i class="el-icon-close"></i></div>
              <div v-else-if="scope.row.craitPro !== 'Support' &&  scope.row.craitPro !=='Not Support'">{{$t(scope.row.craitPro)}}</div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="toolbar">
          <el-button type="primary" class="cur" @click="upgrade">Upgrade Now</el-button>
          <el-button class="cur" @click="getStarted">Get Started</el-button>
        </div> -->
      </div>
    </div>
    <router-view></router-view>
    <wx-mask :maskShow="showWxMask"></wx-mask>
  </div>
</template>

<script>
// import FeatureList from '../FeatureList/FeatureList'
// import { getHost } from '../../utils.js'
import getBrowserInfo from '../../assets/js/browser.js'
import WxMask from '../WxMask'
export default {
  metaInfo () {
    return {
      title: 'Crait | ' + this.$i18n.t('pricing'), // set a title
      meta: [{                 // set meta
        name: 'keyWords',
        content: this.$i18n.t('key-content')
      },
      {
        name: 'description',
        content: this.$i18n.t('description-content')
      }]
    }
  },
//  name: 'Pricing',
  data () {
    return {
      dialogVisible: false,
      tableData: [{
        features: 'tr1-td1',
        crait: 'unlimited',
        craitPro: 'unlimited'
      }, {
        features: 'tr2-td1',
        crait: '200',
//        craitPro: '500'
        craitPro: '1000'
      }, {
        features: 'tr3-td1',
        crait: '20',
        craitPro: 'unlimited'
      }, {
        features: 'tr4-td1',
        crait: '8',
        craitPro: '20'
      }, {
        features: 'tr5-td1',
//        crait: 'Not Support',
        crait: '50MB',
        craitPro: '200MB'
      }, {
        features: 'tr6-td1',
        crait: '100MB',
        craitPro: '1GB'
      }, {
        features: 'tr7-td1',
        crait: 'Support',
        craitPro: 'Support'
      }, {
        features: 'tr8-td1',
        crait: 'tr8-td2',
        craitPro: 'tr8-td3'
      }, {
        features: 'tr9-td1',
        crait: 'tr9-td2',
        craitPro: 'tr9-td3'
      }, {
        features: 'tr10-td1',
        crait: 'Not Support',
        craitPro: 'Not Support'
      }, {
        features: 'tr11-td1',
        crait: 'Support',
        craitPro: 'Support'
      }, {
        features: 'tr12-td1',
        crait: 'tr12-td2',
        craitPro: 'tr12-td3'
      }, {
        features: '',
        crait: 'getStarted',
        craitPro: 'Upgrade'
      }],
      showWxMask: false
    }
  },
  components: {
    WxMask
  },
  created () {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
  methods: {
    getStarted () {
      if (window.document.body.clientWidth <= 1024) {
        const iframe = document.createElement('iframe')
        const body = document.body
        iframe.style.cssText = 'display:none;width=0;height=0'
        body.appendChild(iframe)
        iframe.src = 'batchatnew://?crait'
        if (getBrowserInfo.isAndroid()) {
          if (getBrowserInfo.isWX()) {
            this.showWxMask = true
          } else {
            if (this.$i18n.locale === 'cn') {
              location.href = 'https://www.craitcorp.com/download/crait.apk'
            } else {
              location.href = 'https://play.google.com/store/apps/details?id=com.craitapp.crait'
            }
          }
        } else if (getBrowserInfo.isIOS()) {
          location.href = 'https://itunes.apple.com/app/id1227620003'
        }
      } else {
        window.location.href = `/login/index.html#/login/signup?source=website&v=${new Date().getTime()}`
      }
      // if (window.document.body.clientWidth <= 1024) {
      //   // pre -> share
      //   let href = getHost('share')
      //   window.location.href = href + `/option/share/index.html#/?token=1531291861KhBqlb&type=invite&source=website&v=${new Date().getTime()}`
      // } else {
      //   // del pre
      //   window.location.href = `/login/index.html#/login/signup?source=website&v=${new Date().getTime()}`
      // }
      // window.location.href = `https://share.bat.chat/inv/1531291861KhBqlb?source=website&v=${new Date().getTime()}`
      // window.location.href = `https://bat.chat/login/index.html#/login/signup?source=website&v=${new Date().getTime()}`
      // window.location.href = ` https://pre.bat.chat/inv/1532510125keboAM?source=website&v=${new Date().getTime()}`
      // window.location.href = `https://pre.bat.chat/website/option/share/index.html#/?token=15314629072pKLdA&type=invite&source=website&v=${new Date().getTime()}`
    },
    upgrade () {
      this.$router.push('/Prices/Payment')
    }
  }
}
</script>

<style lang="scss">
  .feature {
    margin-bottom: 1rem;
    .cur {
      cursor: pointer;
    }
    .title {
      color: #323232 !important;
      font-weight: 400 !important;
    }
    //中部
    .mainContent{
      width: 100%;
      background: #fff;
      .key-features {
        .feature-intro {
          .key-feature-lists {
            display: flex;
            -ms-box-orient: horizontal;
            display: -webkit-box;
            display: -moz-box;
            display: -ms-flexbox;
            display: -moz-flex;
            display: -webkit-flex;
            li {
              -webkit-box-flex: 1;      /* OLD - iOS 6-, Safari 3.1-6 */
              -moz-box-flex: 1;         /* OLD - Firefox 19- */
              /* width: 20%; */         /* For old syntax, otherwise collapses. */
              /* 见本文底部评论@Lawrence */
              -webkit-flex: 1;          /* Chrome */
              -ms-flex: 1;              /* IE 10 */
              flex: 1;                  /* NEW, Spec - Opera 12.1, Firefox 20+ */
              margin: 0.5rem 0;
              .feature-img {
                width: 1rem;
                height: 1rem;
                /*background: #E5F0FC;*/
                margin: 0 auto 0.1rem;
                img {
                  width: 1rem;
                  max-width: 100%;
                  height: 1rem;
                  max-height: 100%;
                }
              }
              .feature-title {
                font-size: 0.3rem;
                width: 3rem;
                margin: 0 auto;
                @media screen and (max-width: 760px){
                  font-size: 0.2rem;
                }
              }
            }
          }
        }
        .key-feature-intro {
          margin: 0.5rem auto 0;
          padding: 0 2.3rem;
          @media screen and (min-width: 760px) and (max-width: 1440px) {
            padding: 0;
          }
          @media screen and (max-width: 760px){
            padding: 0;
          }
        }
      }
      .feature-part {
        padding: 0.7rem 0 0;
        text-align: center;
      }
      .feature-info {
        width: 70%;
        margin: 0 auto;
      }
      .other-features {
        margin: 0.5rem auto 0;
      }
      .feature-profile {
        font-size: 0.18rem;
        /*color: #888;*/
        margin: 0.25rem auto 0;
        width: 78%;
      }
      .feature-title {
        font-size: 0.5rem;
        /*color: #303030;*/
        font-weight: 600;
      }
      .feature-intro {
        i {
          display: inline-block;
        }
        .feature-intro-title {
          font-size: 0.4rem;
          width: 57%;
          line-height: 0.6rem;
        }
        .feature-intro-detail {
          width: 67%;
          font-size: 0.3rem;
          color: #888;
          margin: 0.2rem auto;
          line-height: 0.42rem;
          text-align: left;
          @media screen and (min-width: 760px) and (max-width: 1440px) {
            width: 85%;
          }
          @media screen and (max-width: 760px) {
            width: 88%;
          }
        }
      }
      .feature-compare {
        padding: 0 3rem;
        margin-top: 120px;
        @media screen and (min-width: 760px) and (max-width: 1440px) {
          padding: 0 .2rem;
        }
        @media screen and (max-width: 760px) {
          padding: 0 .1rem;
        }
        .self-row:last-child td {
          border: none!important;
          padding-top: 20px;
        }
        // .self-row:last-child:hover {
        //   background: none!important
        // }
        .el-table::before {
          height: 0
        }
        .el-table--enable-row-hover .el-table__body tr:last-child:hover > td {
          background: #fff!important
        }
        .el-table .el-button {
          width: 220px;
          height: 50px;
          font-size: 16px;
          @media screen and (max-width: 760px) {
            width: 1rem;
            height: 0.25rem;
            font-size: 12px;
            padding: 0
          }
        }
        .get-started {
          color: #5ea2ec;
          border: 1px solid #5ea2ec;
        }
        .upgrade {
          background: #5ea2ec;
        }
        .feature-compare-title {
          font-size: 0.4rem;
          text-align: center;
          @media screen and (max-width: 760px) {
            font-size: .3rem;
          }
        }
        .table-title {
          font-size: 0.25rem;
          @media screen and (max-width: 760px) {
            font-size: .2rem;
          }
        }
        .feature-compare-detail{
          font-size: 0.2rem;
          color: #666;
          @media screen and (max-width: 760px) {
            font-size: .17rem;
          }
          .cell {
            word-break: break-word!important;
            line-height: 30px;
            .el-icon-close {
              color: #e7345e;
              font-weight: bold;
            }
            .el-icon-check {
              color: #5795e2;
              font-weight: bold;
            }
          }
        }
      }
      // .feature-contact-us {
      //   width: 3.4rem;
      //   height: 0.6rem;
      //   background: #00a3d8;
      //   color: #fff;
      //   position: absolute;
      //   left: 50%;
      //   margin-left: -1.7rem;
      //   font-size: 0.3rem;
      //   line-height: 0.6rem;
      // }
      // .feature-sign-up {
      //   display: block;
      //   width: 3.4rem;
      //   height: 0.6rem;
      //   background: #069c34;
      //   color: #fff;
      //   font-size: 0.3rem;
      //   line-height: 0.6rem;
      //   margin: 0.3rem auto;
      // }
      /*.feature-part:nth-of-type(odd) {*/
        /*background: #fafafa;*/
      /*}*/
      @media screen and (max-width: 760px){
        .feature-part {
          padding: 0.3rem 0;
          .feature-info {
            width: 95%;
            margin-bottom: 0.5rem;
            .feature-title {
              font-size: 0.2rem;
            }
          }
          .feature-intro {
            /*display: block;*/
            flex-direction: column-reverse;
            .tool-pic {
              padding: 0;
            }
            .feature-intro-title {
              font-size: 0.2rem;
              width: 100%;
              line-height: 0.3rem;
            }
            .feature-intro-detail {
              font-size: 0.16rem;
              /*width: 95%;*/
              line-height: 0.24rem;
            }
            .feature-crait-advantage-intro, .secureCommunication {
              margin-left: 0.2rem;
              padding: 0;
            }
            .organization .feature-intro-title {
              width: 100%;
            }
            .key-feature-lists {
              display: block;
            }
          }
          .feature-intro:nth-of-type(3) {
            flex-direction: column;
          }
        }
        .download {
          .feature-info {
            margin-bottom: 0;
          }
        }
      }
      // .feature-contact-us {
      //   width: 2.5rem;
      //   height: 0.4rem;
      //   line-height: 0.4rem;
      //   margin-left: -1.25rem;
      //   font-size: 0.2rem;
      // }
      // .feature-sign-up {
      //   width: 2.5rem;
      //   height: 0.4rem;
      //   line-height: 0.4rem;
      //   /*<!--margin-left: -1.25rem;-->*/
      //   font-size: 0.2rem;
      // }
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?5c2f0a3e